import React from 'react';
import { MessageSquare } from 'lucide-react';

const ChatMockup: React.FC = () => {
  return (
    <div className="bg-gray-50 rounded-2xl p-4 h-[380px] flex flex-col shadow-lg overflow-hidden">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-bold text-gray-800">Team Chat with AI</h3>
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#3b82f6"
              strokeWidth="2"
            >
              <path d="M11 19c-1.66 0-3-1.34-3-3V8c0-1.66 1.34-3 3-3h10c1.66 0 3 1.34 3 3v8c0 1.66-1.34 3-3 3h-3l-4 4z" />
              <line x1="8" y1="9" x2="4" y2="9" />
              <line x1="8" y1="13" x2="3" y2="13" />
              <line x1="7" y1="17" x2="2" y2="17" />
            </svg>
          </div>
        </div>
      </div>

      {/* Chat messages */}
      <div className="flex-1 overflow-y-auto space-y-4 pr-2">
        {/* Message 1 */}
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0">
            <span className="text-white text-xs font-bold">AI</span>
          </div>
          <div className="bg-white p-3 rounded-lg shadow-sm max-w-[80%] text-sm">
            <p className="text-gray-700">
              Welcome to the new project! How can I help you get started today?
            </p>
          </div>
        </div>

        {/* Message 2 */}
        <div className="flex items-start gap-3 justify-end">
          <div className="bg-blue-500 p-3 rounded-lg shadow-sm max-w-[80%] text-sm">
            <p className="text-white">
              I need to brainstorm some ideas for our new marketing campaign.
            </p>
          </div>
          <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
            <span className="text-green-700 text-xs font-bold">ME</span>
          </div>
        </div>

        {/* Message 3 */}
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0">
            <span className="text-white text-xs font-bold">AI</span>
          </div>
          <div className="bg-white p-3 rounded-lg shadow-sm max-w-[80%] text-sm">
            <p className="text-gray-700">
              Great! Let's start by identifying our target audience and key messaging points. Based
              on your previous campaigns, I suggest focusing on these areas:
            </p>
            <ul className="list-disc pl-5 mt-2 text-gray-700 space-y-1">
              <li>Value proposition for new customers</li>
              <li>Seasonal promotions for Q2</li>
              <li>Social media content strategy</li>
            </ul>
            <p className="mt-2 text-gray-700">
              Would you like me to elaborate on any of these points?
            </p>
          </div>
        </div>

        {/* Message 4 */}
        <div className="flex items-start gap-3 justify-end">
          <div className="bg-blue-500 p-3 rounded-lg shadow-sm max-w-[80%] text-sm">
            <p className="text-white">
              Let's focus on the social media strategy. What are your recommendations?
            </p>
          </div>
          <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
            <span className="text-green-700 text-xs font-bold">ME</span>
          </div>
        </div>
      </div>

      {/* Chat input */}
      <div className="pt-3 border-t border-gray-200 mt-2">
        <div className="relative">
          <input
            type="text"
            placeholder="Type your message..."
            className="w-full py-2 px-4 pr-10 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <button className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="22" y1="2" x2="11" y2="13"></line>
              <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export const chatMockupData = {
  type: 'AI Team Chat',
  icon: MessageSquare,
  description:
    'Collaborate with an AI assistant that understands your projects and helps you stay productive. Get instant answers, brainstorm ideas, overcome creative blocks, and generate content - all within your workspace.',
  mockup: <ChatMockup />,
};

export default ChatMockup;
